import React from 'react'
import ReplyIcon from '@mui/icons-material/Reply';
import CheckIcon from '@mui/icons-material/Check';
import { IconButton } from '@mui/material';
import DoneAllIcon from '@mui/icons-material/DoneAll';

import { QuoteItemCommentResponse } from '@/main/models/response';

import * as S from './styles';
import { getTranslateByKey, isNullUndefined } from '@/main/services/utils';
import { isEmpty } from 'lodash';
import DoubleCheckIcon from '@/main/components/shared/icons/doubleCheckIcon';
import RenderTooltipMessage from '@/main/components/shared/renderTooltipMessage/renderTooltipMessage';

export interface ICommentProps {
  comment: QuoteItemCommentResponse;
  comments: QuoteItemCommentResponse[];
  replyComment: (idComment: string) => void;
}
function Comment({
  comment,
  comments,
  replyComment
}: ICommentProps) {

  const findedMessageReply = comments.find(i => i.guidQuoteItemComment === comment.guidReplyComment);
  const isVisualized = !isEmpty(comment.visualisationDateFormatted);
  const tooltipMessage = `${getTranslateByKey('information.sendTo')}: ${comment.recipientCompanyType}\n${getTranslateByKey('information.whoSees')}: ${comment.companyTypePermissions.join(', ')}`;

  return (
    <S.AreaComment $isOwner={comment.isSender}>
      <RenderTooltipMessage tooltipMessage={tooltipMessage}>
        <S.Message $isOwner={comment.isSender}>
          {!isNullUndefined(findedMessageReply) && (
            <S.MessageReply>
              {findedMessageReply.senderCompany} - {findedMessageReply.dateFormatted} <br />
              {findedMessageReply.text}
            </S.MessageReply>
          )}
          {comment.text}
          <S.AreaButtons>
            <IconButton
              id='id-searchClaim-button-reply'
              onClick={() => replyComment(comment.guidQuoteItemComment)}
            >
              <ReplyIcon fontSize='small' />
            </IconButton>
          </S.AreaButtons>
        </S.Message>
        <S.FooterMessage>
          <S.FooterMessageLeft>
            <S.NameSender title={comment.senderCompany}>{comment.senderCompany}</S.NameSender> - {comment.dateFormatted}
          </S.FooterMessageLeft>
          <S.FooterMessageRight>
            {comment.visualisationDateFormatted}
            {isVisualized ?
              <DoubleCheckIcon color='#3f5ec9' /> :
              <CheckIcon style={{ fontSize: '16px', color: 'inherit' }} />}
          </S.FooterMessageRight>
        </S.FooterMessage>
      </RenderTooltipMessage>
    </S.AreaComment>
  )
}

export default Comment